<template>
  <v-container grid-list-lg>
    <v-row>
      <v-col class="pa-0">
        <v-card class="elevation-0 transparent">
          <v-row>
            <v-col>
              <v-data-table
                :headers="headers"
                :items="manufacturingCommands"
                :search="search"
                :items-per-page="15"
                class="transparent"
                dense
              >
                <template v-slot:top>
                  <v-toolbar flat color="white" class="transparent">
                    <v-toolbar-title>Výrobné príkazy</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>

                    <v-btn to="/manufacturing-commands/add" exact text>
                      Vytvoriť
                      <v-icon color="primary" class="pl-2">mdi-plus-circle</v-icon>
                    </v-btn>

                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-toolbar>
                </template>
                <template v-slot:item.manufacturingCommandStatus="{ item }">
                  <Tooltip :data="getCommandStatus(item)" />
                </template>
                <template v-slot:item.created="{ item }">
                  <span>{{ item.created | moment("dddd, Do MMMM YYYY o HH:mm") }}</span>
                </template>
                <template v-slot:item.finishTime="{ item }">
                  <span
                    v-if="item.finishTime"
                  >{{ item.finishTime | moment("dddd, Do MMMM YYYY o HH:mm") }}</span>
                  <span v-else>-</span>
                </template>
                <template v-slot:item.startTime="{ item }">
                  <span
                    v-if="item.startTime"
                  >{{ item.startTime | moment("dddd, Do MMMM YYYY o HH:mm") }}</span>
                  <span v-else>-</span>
                </template>
                <template v-slot:item.action="{ item }">
                  <CommandButtonGroup
                    :command="item"
                    @edit-click="editClick"
                    @detail-click="detailClick"
                    @confirm-click="confirmClick"
                    @delete-click="deleteClick"
                  />
                </template>
              </v-data-table>
            </v-col>

            <CommandWorkplaceState ref="commandWorkplaceState" />
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Tooltip from "@/views/manufacturing_command/components/Tooltip";
import CommandButtonGroup from "@/views/manufacturing_command/components/CommandButtonGroup";
import CommandWorkplaceState from "@/views/manufacturing_command/components/CommandWorkplaceState";

import UnitOfWorkService from "@/services/UnitOfWorkService";
import { tableHeader, tableHeaderDetail } from "./js/tableHeaders";
import { getCommandStatus } from "./js/manufacturingCommand";

export default {
  name: "Order",
  components: {
    CommandWorkplaceState,
    Tooltip,
    CommandButtonGroup
  },
  data: () => ({
    dialog: false,
    headers: tableHeader,
    headersDetail: tableHeaderDetail,
    manufacturingCommands: [],
    manufacturingCommandDetail: null,
    search: "",
    getCommandStatus: getCommandStatus
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.openGlobalLoader("Načítava sa ...");
      this.services
        .manufacturingCommandService()
        .getManufacturingCommands()
        .then(response => {
          this.manufacturingCommands = response.data;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    detailClick(command) {
      this.$refs.commandWorkplaceState.openDialog(command.id);

      // this.openGlobalLoader("Načítava sa ...");
      // new UnitOfWorkService()
      //   .manufacturingCommandService()
      //   .getManufacturingCommandInProduction(command.id)
      //   .then(response => {
      //     this.manufacturingCommandDetail = response.data;
      //     this.dialog = true;
      //   })
      //   .finally(() => {
      //     this.closeGlobalLoader();
      //   });
    },

    editClick(command) {
      this.$router.push(`/manufacturing-commands/${command.id}`);
    },

    confirmClick(command) {
      this.openGlobalLoader("Potvrdzuje sa ...");
      new UnitOfWorkService()
        .manufacturingCommandService()
        .putManufacturingCommandConfirmation(command.id)
        .then(response => {
          if (this.checkResponse(response)) {
            console.log("response is ok");
          } else {
            this.openGlobalAlert(
              this.getTranslate("errors." + response.data.code),
              "error"
            );
            return;
          }
          this.initialize();
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    // cancelClick(command) {
    //   this.openGlobalLoader("Potvrdzuje sa ...");
    //   new UnitOfWorkService()
    //     .manufacturingCommandService()
    //     .putManufacturingCommandCancelation(command.id)
    //     .then(() => {
    //       this.initialize();
    //     })
    //     .finally(() => {
    //       this.closeGlobalLoader();
    //     });
    // },
    deleteClick(command) {
      this.openGlobalLoader("Maže sa ...");
      new UnitOfWorkService()
        .manufacturingCommandService()
        .deleteManufacturingCommand(command.id)
        .then(() => {
          this.initialize();
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    }
  }
};
</script>
